import React from "react";
import { Logo } from "./Logo";
import { footerColumns } from "../data/content";
export function Footer() {
  return <footer className="bg-band pb-10 pt-20" data-id="element-124" data-mp="3gg10g6ubc3z8">
      <div className="container-x" data-id="element-125" data-mp="3gh3swj7aaeh9">
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr_1fr]" data-id="element-126" data-mp="32onjn0nshk7w">
          <div data-id="element-127" data-mp="36pfvm1o1q37v">
            <Logo data-id="element-128" data-mp="36oy0j8d4dv1j" />
            <p className="mt-5 max-w-[320px] text-[14px] leading-relaxed text-body" data-id="element-129" data-mp="36qhfmvn1i01q">
              Ad films, series and social videos for brands — directed by people, produced with AI, built to sell.
            </p>
          </div>
          {footerColumns.map(col => <nav key={col.title} aria-label={col.title} data-id="element-130" data-mp="3levhb38pzigp">
              <p className="font-mono text-[12px] tracking-[0.12em] text-foot" data-id="element-131" data-mp="3lggbusv1b1ek">{col.title}</p>
              <ul className="mt-5 flex flex-col gap-3" data-id="element-132" data-mp="3qblxrrofsg2n">
                {col.links.map(link => <li key={link.label} data-id="element-133" data-mp="29xvtajtenpsh">
                    <a href={link.href} {...link.external && link.href.startsWith("http") ? {
                target: "_blank",
                rel: "noreferrer"
              } : {}} className="font-mono text-[13px] uppercase tracking-[0.06em] text-body transition-colors duration-150 hover:text-white" data-id="element-134" data-mp="2eyt6sj3gzvnn">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </nav>)}
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-quiet pt-6 font-mono text-[12px] tracking-[0.1em] text-foot md:flex-row md:justify-between" data-id="element-135" data-mp="82ihs7hrf0lp">
          <span data-id="element-136" data-mp="31umvaqetzm7">BLR, INDIA · NY, USA · WORKING WORLDWIDE</span>
          <span data-id="element-137" data-mp="hrigdpscntzd">© BRANDHERO CREATIVE</span>
        </div>
      </div>
    </footer>;
}